import React, { useState, useRef, useContext } from 'react';
// Import custom hooks
import { useFormContext } from 'react-hook-form';
import useStepLogic from 'components/Form/useStepLogic';

// Import components
import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
// import useFormData from '../../../useFormData';

import Date from '../Date/Date';

const Event = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  // Check it we are facing an existing user

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      <SectionStepInfo section="Section 2 of 2" description="About the incident" />

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="ds-fe-fieldset ds-col-1">
        <legend className="ds-fe-fieldset__legend">
          <h2 className="ds-fe-question">When did the incident happen?</h2>
        </legend>
        <Date />
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default Event;
